module.exports = __webpack_public_path__ + "img/besler.75261a75.jpg";